import React from "react";
import TableSettlementWithReceiver from "../../supplierPayment/tableSettlementWithReceiver";

export default function PaymentPage() {

    return (
        <div>

            <TableSettlementWithReceiver />
        </div>
    );

}
